import React, {Component} from 'react';
import {action, observable} from 'mobx';
import {inject, observer} from 'mobx-react';
import {Button, FormInput, FormSelect} from 'shards-react';
import FeatherIcon from 'feather-icons-react';
import {toast} from 'react-toastify';
import moment from 'moment';
import PageTitle from '../../../components/common/PageTitle';

@inject(({teamUser}) => ({isLogin: teamUser.isLogin, me: teamUser.me}))
@inject(({AOA}) => ({getBankTransferOrderList: AOA.getBankTransferOrderList}))
@observer
class BankTransferList extends Component {

  @observable list = {docs: [], totalDocs: 0, page: 1, totalPages: 1};
  @observable loading = false;
  @observable params = {
    page: 1,
    limit: 30,
    searchParams: {
      keyword: '',
      taxInvoiceIssued: null, // null=전체, true, false
      startDateFrom: '',
      startDateTo: ''
    }
  };

  componentDidMount() {
    this.load();
  }

  @action load = async () => {
    this.loading = true;
    try {
      const sp = Object.assign({}, this.params.searchParams);
      // null 값은 보내지 않음
      if (sp.taxInvoiceIssued === null) delete sp.taxInvoiceIssued;
      if (!sp.keyword) delete sp.keyword;
      if (!sp.startDateFrom) delete sp.startDateFrom;
      if (!sp.startDateTo) delete sp.startDateTo;
      const res = await this.props.getBankTransferOrderList({
        page: this.params.page,
        limit: this.params.limit,
        searchParams: sp
      });
      if (res && res.errors) {
        toast.error(res.errors[0].message || '조회 실패');
        this.list = {docs: [], totalDocs: 0, page: 1, totalPages: 1};
      } else if (res) {
        this.list = res;
      }
    } catch (e) {
      console.error(e);
      toast.error('조회 중 오류가 발생했습니다.');
    } finally {
      this.loading = false;
    }
  };

  @action onChangeKeyword = (e) => { this.params.searchParams.keyword = e.target.value; };
  @action onChangeTaxFilter = (e) => {
    const v = e.target.value;
    this.params.searchParams.taxInvoiceIssued = v === '' ? null : (v === 'true');
  };
  @action onChangeFrom = (e) => { this.params.searchParams.startDateFrom = e.target.value; };
  @action onChangeTo = (e) => { this.params.searchParams.startDateTo = e.target.value; };
  @action onChangeLimit = (e) => { this.params.limit = parseInt(e.target.value, 10) || 30; this.params.page = 1; this.load(); };

  @action search = (e) => {
    if (e && e.preventDefault) e.preventDefault();
    this.params.page = 1;
    this.load();
  };

  @action goPage = (n) => {
    if (n < 1 || n > (this.list.totalPages || 1)) return;
    this.params.page = n;
    this.load();
  };

  copyText = (text) => {
    try {
      const tmp = document.createElement('textarea');
      tmp.value = text;
      document.body.appendChild(tmp);
      tmp.select();
      document.execCommand('copy');
      document.body.removeChild(tmp);
      toast.success('복사되었습니다.');
    } catch (e) {
      toast.error('복사 실패');
    }
  };

  fmt = (n) => (n || 0).toLocaleString('ko-KR');

  render() {
    const docs = this.list.docs || [];
    const total = this.list.totalDocs || 0;
    const totalPages = this.list.totalPages || 1;
    const sp = this.params.searchParams;

    return (
      <div className="main-content">
        <PageTitle/>
        <div className="widget-box bank-transfer-list-page" style={{padding: '20px 24px'}}>

          <div style={{marginBottom: 16}}>
            <h3 style={{margin: '0 0 4px', fontSize: 18, fontWeight: 700, color: '#1F2937'}}>통장입금 처리 내역</h3>
            <p style={{margin: 0, fontSize: 13, color: '#6B7280'}}>
              관리자가 수동 처리한 통장입금 결제 기록을 확인합니다. 사업자번호 / 세금계산서 이메일 / 사유 / 스토어명으로 검색할 수 있습니다.
            </p>
          </div>

          {/* 검색 폼 */}
          <form onSubmit={this.search} style={{display: 'flex', alignItems: 'center', gap: 8, padding: '12px 14px', background: '#F9FAFB', border: '1px solid #E5E7EB', borderRadius: 8, marginBottom: 12, flexWrap: 'wrap'}}>
            <div style={{display: 'flex', alignItems: 'center', gap: 6}}>
              <FeatherIcon icon="search" size="14" style={{color: '#9CA3AF'}}/>
              <FormInput placeholder="검색 (사업자번호 / 이메일 / 사유 / 스토어명)"
                         value={sp.keyword || ''}
                         onChange={this.onChangeKeyword}
                         style={{minWidth: 280}}/>
            </div>
            <FormSelect value={sp.taxInvoiceIssued == null ? '' : String(sp.taxInvoiceIssued)}
                        onChange={this.onChangeTaxFilter}
                        style={{width: 160}}>
              <option value="">세금계산서 전체</option>
              <option value="true">발행 요청</option>
              <option value="false">미요청</option>
            </FormSelect>
            <div style={{display: 'flex', alignItems: 'center', gap: 4, fontSize: 12, color: '#6B7280'}}>
              <span>처리일</span>
              <FormInput type="date" value={sp.startDateFrom || ''} onChange={this.onChangeFrom} style={{width: 140}}/>
              <span>~</span>
              <FormInput type="date" value={sp.startDateTo || ''} onChange={this.onChangeTo} style={{width: 140}}/>
            </div>
            <Button type="submit" theme="primary" size="sm">
              <FeatherIcon icon="search" size="14"/> 검색
            </Button>
            <div style={{marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: 8}}>
              <FormSelect value={this.params.limit} onChange={this.onChangeLimit} style={{width: 90}}>
                <option value="20">20개</option>
                <option value="30">30개</option>
                <option value="50">50개</option>
                <option value="100">100개</option>
              </FormSelect>
              <Button theme="light" size="sm" onClick={() => this.load()}>
                <FeatherIcon icon="refresh-cw" size="14"/> 새로고침
              </Button>
            </div>
          </form>

          <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 8, fontSize: 13, color: '#4B5563'}}>
            <span>전체 <b style={{color: '#1F2937'}}>{this.fmt(total)}</b>건</span>
            {this.loading && (
              <span style={{display: 'inline-flex', alignItems: 'center', gap: 4, color: '#4A6CF7'}}>
                <FeatherIcon icon="loader" size="13"/> 로딩 중…
              </span>
            )}
          </div>

          <div style={{border: '1px solid #E5E7EB', borderRadius: 8, overflow: 'auto', background: '#fff'}}>
            <table style={{width: '100%', borderCollapse: 'collapse', fontSize: 12}}>
              <thead>
                <tr style={{background: '#F9FAFB', color: '#6B7280', fontWeight: 600}}>
                  <th style={th}>처리일시</th>
                  <th style={th}>스토어 / 샵</th>
                  <th style={th}>입금 금액</th>
                  <th style={th}>공급가액</th>
                  <th style={th}>부가세</th>
                  <th style={th}>사용 시작</th>
                  <th style={th}>사용 종료</th>
                  <th style={th}>세금계산서</th>
                  <th style={th}>사유</th>
                  <th style={th}>처리자</th>
                </tr>
              </thead>
              <tbody>
                {docs.length === 0 ? (
                  <tr>
                    <td colSpan={10} style={{padding: '40px 20px', textAlign: 'center', color: '#9CA3AF'}}>
                      <FeatherIcon icon="inbox" size="36" style={{color: '#D1D5DB', marginBottom: 8}}/>
                      <div>처리 내역이 없습니다.</div>
                    </td>
                  </tr>
                ) : docs.map((d) => {
                  const storeName = (d.store_id && (d.store_id.name || d.store_id.platformId)) || d.storeName || '-';
                  const isExpired = d.endDate && moment(d.endDate).isBefore(moment(), 'day');
                  return (
                    <tr key={d._id} style={{borderTop: '1px solid #F3F4F6'}}>
                      <td style={td}>{d.createdAt ? moment(d.createdAt).format('YYYY-MM-DD HH:mm') : '-'}</td>
                      <td style={td}>
                        <div style={{fontWeight: 600, color: '#1F2937'}}>{storeName}</div>
                        <div style={{fontSize: 11, color: '#6B7280'}}>Shop#{d.shopNo}</div>
                      </td>
                      <td style={Object.assign({}, td, {textAlign: 'right', fontWeight: 700, color: '#1F2937'})}>{this.fmt(d.totalAmount)}원</td>
                      <td style={Object.assign({}, td, {textAlign: 'right'})}>{this.fmt(d.supplyAmount)}원</td>
                      <td style={Object.assign({}, td, {textAlign: 'right'})}>{this.fmt(d.vatAmount)}원</td>
                      <td style={td}>{d.startDate ? moment(d.startDate).format('YYYY-MM-DD') : '-'}</td>
                      <td style={Object.assign({}, td, {color: isExpired ? '#DC2626' : '#1F2937', fontWeight: isExpired ? 600 : 400})}>
                        {d.endDate ? moment(d.endDate).format('YYYY-MM-DD') : '-'}
                        {isExpired && <span style={{marginLeft: 4, fontSize: 10, color: '#DC2626'}}>(만료)</span>}
                      </td>
                      <td style={td}>
                        {d.taxInvoiceIssued ? (
                          <>
                            <span style={{display: 'inline-block', padding: '2px 8px', background: '#FEF3C7', color: '#92400E', borderRadius: 100, fontSize: 10, fontWeight: 700}}>요청됨</span>
                            <div style={{marginTop: 4, fontSize: 11, color: '#374151'}}>
                              {d.taxInvoiceEmail && (
                                <div style={{display: 'flex', alignItems: 'center', gap: 4}}>
                                  <span title={d.taxInvoiceEmail} style={{maxWidth: 160, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}>{d.taxInvoiceEmail}</span>
                                  <FeatherIcon icon="copy" size="11" style={{cursor: 'pointer', color: '#9CA3AF'}} onClick={() => this.copyText(d.taxInvoiceEmail)}/>
                                </div>
                              )}
                              {d.businessRegNumber && (
                                <div style={{display: 'flex', alignItems: 'center', gap: 4}}>
                                  <span style={{color: '#6B7280'}}>{d.businessRegNumber}</span>
                                  <FeatherIcon icon="copy" size="11" style={{cursor: 'pointer', color: '#9CA3AF'}} onClick={() => this.copyText(d.businessRegNumber)}/>
                                </div>
                              )}
                            </div>
                          </>
                        ) : (
                          <span style={{color: '#9CA3AF', fontSize: 11}}>미요청</span>
                        )}
                      </td>
                      <td style={Object.assign({}, td, {maxWidth: 240, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'})} title={d.bankTransferReason || ''}>
                        {d.bankTransferReason || '-'}
                      </td>
                      <td style={Object.assign({}, td, {fontSize: 11, color: '#6B7280'})}>{d.manualBy || '-'}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>

          {docs.length > 0 && (
            <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 12, marginTop: 12, fontSize: 13}}>
              <Button theme="light" size="sm" disabled={this.params.page <= 1} onClick={() => this.goPage(this.params.page - 1)}>
                <FeatherIcon icon="chevron-left" size="14"/> 이전
              </Button>
              <span>{this.params.page} / {totalPages}</span>
              <Button theme="light" size="sm" disabled={this.params.page >= totalPages} onClick={() => this.goPage(this.params.page + 1)}>
                다음 <FeatherIcon icon="chevron-right" size="14"/>
              </Button>
            </div>
          )}

        </div>
      </div>
    );
  }
}

const th = {padding: '10px 12px', borderBottom: '1px solid #E5E7EB', textAlign: 'left', fontSize: 12, whiteSpace: 'nowrap', position: 'sticky', top: 0};
const td = {padding: '10px 12px', verticalAlign: 'middle', color: '#1F2937'};

export default BankTransferList;
